<template>
    <Chart  @getData='getData'>
        <template #v>
            <div id="echart_three_one"></div>
        </template>
    </Chart>
</template>

<script>
import Chart from "../components/chart";
export default {
    name: "",
    data() {
        return {

        };
    },
    methods: {
        getData(plan,echarts,times) {
            let { axis,grid,title,legend } = plan

            let option = {
                color: ['#ff5755','#00affb'],
                title: {
                    text: "财政收入、支出对比",
                    ...title,
                },
                legend: {
                    ...legend,
                    data: [],
                    right: 60,
                    top: 20,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                    formatter: (params) => {
                        params = params.map(item=>{
                            if(item.value<0) {
                                item.value = 0 - item.value
                            }
                            return item
                        })
                        return `${params[0].axisValue}<br/>${params[0].marker}${params[0].seriesName}:${params[0].value}<br/>${params[1].marker}${params[1].seriesName}:${params[1].value}`
                    }
                },
                grid: {
                    ...grid,
                    right:'10%',
                    left: '1%'
                },
                xAxis: {
                    name: "",
                    ...axis,
                    position:'top',
                    nameLocation:'end'
                },
                yAxis: {
                    name: "",
                    data: [],
                    ...axis
                },
                series: [],
            };
            var url =
                this.urlobj.dx_jjfxty +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=27,29`;
            this.$get(url).then((res) => {
                let data = res.rows[0].data;
                option.xAxis.name = data[0].dataArr[0].units
                let x = data[0].dataArr.map((item) => item.name);
                
                option.legend.data = x.reverse();
                option.series = x.map((item) => {
                    return {
                        name: item,
                        data: [],
                        type: "bar",
                        barWidth: '12px',
                        itemStyle: {
                            barBorderRadius: 4,
                        },
                        stack:'总量'
                    };
                });
                let arr = [];
                data.forEach((item) => {
                    option.yAxis.data.push(item.time);
                    
                    let obj = {};
                    item.dataArr.forEach((itemx,index) => {
                        if( index%2 == 0 ) {
                            obj[itemx.name] = itemx.value;
                        }else {
                            obj[itemx.name] = -itemx.value;
                        }
                        
                    });
                    arr.push(obj);
                });
                option.series.forEach((item) => {
                    arr.forEach((itemx) => {
                        item.data.push(itemx[item.name]);
                        //显示后5年的
                        item.data = item.data.slice(-5)
                    });
                });
                option.yAxis.data = option.yAxis.data.slice(-5)
                var myChart = echarts.init(
                    document.getElementById("echart_three_one")
                );

                myChart.setOption(option);

                
            });
        },
    },
    created() {

    },
    components: {
        Chart,
    },
};
</script>

<style lang="less" scoped>
#echart_three_one {
    height:250px
}
</style>
